'use client';
import {ThemeImage} from '@components/ThemeImage';
import {Button} from '@lib/components/ui/button';
import {VStack} from '@linx-security/ui';
import ImageDark from '@public/images/empty-states/errors/cone-tilted/cone-tilted-dark.svg';
import ImageLight from '@public/images/empty-states/errors/cone-tilted/cone-tilted.svg';
import type {MouseEvent} from 'react';
import React from 'react';

type TextProps = {
  text?: string;
  show: boolean;
};
type ImageProps =
  | {
      show: true;
      src: string;
      height: number;
      width: number;
    }
  | {show: false};
type Props = {
  handleReset: (e?: MouseEvent<HTMLButtonElement>) => unknown;
  image?: ImageProps;
  heading?: TextProps;
  contact?: TextProps;
  button?: {
    text?: string;
  };
};

const BaseErrorPage = ({handleReset, image, heading, button}: Props) => {
  const headingText = heading?.text || `Oops! Something Went Wrong`;
  const buttonText = button?.text || `Try again`;

  return (
    <VStack spacing={8} justifyContent={`center`} height={`100%`}>
      {image?.show !== false && (
        <ThemeImage
          style={{
            objectFit: `contain`,
            pointerEvents: `none`,
            userSelect: `none`,
            width: `320px`,
            height: `320px`,
          }}
          srcDark={ImageDark}
          srcLight={ImageLight}
          alt={`error-image`}
          data-testid={`error-image`}
        />
      )}
      {heading?.show !== false && (
        <p className={`text-header-md mb-space-200`} data-testid={`error-heading`}>
          {headingText}
        </p>
      )}

      <Button variant={'primary'} size="lg" onClick={handleReset} data-testid={`error-reload-button`}>
        {buttonText}
      </Button>
    </VStack>
  );
};

export default BaseErrorPage;
export type {Props as BaseErrorPageProps};
